function alertIncludeExcludeOnlyParameterController(constantsService) {
    const $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.includeExcludeOnly = constantsService.includeExcludeOnly.enums;
        $ctrl.selectedValue = $ctrl.model;
    };


    $ctrl.$onChanges = function (changes) {
        if (changes.model && changes.model.currentValue !== $ctrl.selectedValue) {
            $ctrl.selectedValue = changes.model.currentValue;
        }
    };

    $ctrl.includeExcludeOnlyChanged = function () {
        $ctrl.onUpdate({ value: $ctrl.selectedValue });
    };
}

angular
    .module("angus.components")
    .component("alertIncludeExcludeOnlyParameter", {
        controller: alertIncludeExcludeOnlyParameterController,
        bindings: {
            label: "<",
            model: "<",
            isReadOnly: "<",
            onUpdate: "&",
            isRequired: '<'
        },
        template: `
<label class="control-label" for="includeExcludeOnly">{{$ctrl.label}} <span class="red" ng-if="$ctrl.isRequired">*</span></label>
<select
    class="form-control"
    ng-model="$ctrl.selectedValue"
    ng-change="$ctrl.includeExcludeOnlyChanged()"
    ng-disabled="!$ctrl.includeExcludeOnly.length || $ctrl.isReadOnly"
    ng-options="option.value.id as option.value.display for option in $ctrl.includeExcludeOnly"
    ng-required="$ctrl.isRequired"
    >
</select>
        `
    });
